/* eslint-disable sonarjs/cognitive-complexity */

import React from 'react';
import {
  ContentList,
  ContentQuestions,
  Description,
  DEscriptionAccordion,
  TittleAccordion,
} from './recomendation-for-interview-style';
import { BaSeAccordion, BaSeIcon } from '@base/react';

export const RecomendationForInterview = () => {
  const [openAccordion, setOpenAccordion] = React.useState(null);

  const handleAccordionChange = (accordionName) => (index) => {
    if (index === undefined) {
      setOpenAccordion(null);
    } else {
      setOpenAccordion(openAccordion === accordionName ? null : accordionName);
    }
  };

  return (
    <div>
      <Description>
        A entrevista com IA é uma etapa decisiva da sua jornada. Ela nos ajuda a
        entender seu preparo, seu perfil e sua conexão com os valores do
        Empretec. A entrevista é <strong>online, gratuita </strong>
        e <strong>composta por 5 perguntas,</strong> baseadas nas suas
        experiências profissionais empresariais ou pessoais.
      </Description>

      <ContentQuestions>
        <BaSeAccordion
          startOpen={openAccordion === 'first' ? 0 : undefined}
          onOpenIndexChange={handleAccordionChange('first')}
          backgroundContentColor={'#215DF4'}
          backgroundTitleColor={'#215DF4'}
          clickableTitle={true}
          shadow="0"
          titleButtonIconSize="small"
          titleButtonSize="small"
          options={[
            {
              content: (
                <ContentList>
                  <ul>
                    <li>
                      <BaSeIcon
                        name="system/checkbox-blank-circle-fill"
                        size="8"
                        color="#fff"
                        description="icon-lightulb-als"
                      />
                      <p>
                        Faça a entrevista com calma, em um ambiente tranquilo.
                      </p>
                    </li>
                    <li>
                      <BaSeIcon
                        name="system/checkbox-blank-circle-fill"
                        size="8"
                        color="#fff"
                        description="icon-lightulb-als"
                      />
                      <p>
                        Reserve pelo menos <strong>50 minutos</strong> para
                        responder com atenção.
                      </p>
                    </li>
                    <li>
                      <BaSeIcon
                        name="system/checkbox-blank-circle-fill"
                        size="8"
                        color="#fff"
                        description="icon-lightulb-als"
                      />
                      <p>
                        Esteja em boas condições físicas, mentais e emocionais.
                      </p>
                    </li>
                    <li>
                      <BaSeIcon
                        name="system/checkbox-blank-circle-fill"
                        size="8"
                        color="#fff"
                        description="icon-lightulb-als"
                      />
                      <p>
                        Se não for o momento ideal, tudo bem. Volte quando
                        estiver pronto.
                      </p>
                    </li>
                  </ul>
                </ContentList>
              ),
              title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <BaSeIcon
                    name="document/todo-line"
                    size="22"
                    color="#fff"
                    description="icon-lightulb-als"
                  />
                  <TittleAccordion>Recomendações práticas</TittleAccordion>
                </div>
              ),
            },
          ]}
          radius={30}
          titleColor="#ffffff"
        />

        <BaSeAccordion
          clickableTitle={true}
          startOpen={openAccordion === 'second' ? 0 : undefined}
          onOpenIndexChange={handleAccordionChange('second')}
          backgroundContentColor={'#215DF4'}
          backgroundTitleColor={'#215DF4'}
          titleButtonIconSize="small"
          titleButtonSize="small"
          shadow="0"
          options={[
            {
              content: (
                <ContentList>
                  <ul>
                    <li>
                      <BaSeIcon
                        name="system/checkbox-blank-circle-fill"
                        size="8"
                        color="#fff"
                        description="icon-lightulb-als"
                      />
                      <p>O Empretec tem base comportamental.</p>
                    </li>

                    <li>
                      <BaSeIcon
                        name="system/checkbox-blank-circle-fill"
                        size="8"
                        color="#fff"
                        description="icon-lightulb-als"
                      />
                      <p>Escreva com autenticidade e foco pessoal.</p>
                    </li>

                    <li>
                      <BaSeIcon
                        name="system/checkbox-blank-circle-fill"
                        size="8"
                        color="#fff"
                        description="icon-lightulb-als"
                      />
                      <p>
                        Você será desafiado — e isso é parte da transformação.
                      </p>
                    </li>

                    <li>
                      <BaSeIcon
                        name="system/checkbox-blank-circle-fill"
                        size="8"
                        color="#fff"
                        description="icon-lightulb-als"
                      />
                      <p>
                        Cada palavra importa — evite encher o texto só para
                        atingir o mínimo.
                      </p>
                    </li>

                    <li>
                      <BaSeIcon
                        name="system/checkbox-blank-circle-fill"
                        size="8"
                        color="#fff"
                        description="icon-lightulb-als"
                      />
                      <p>
                        A entrevista ajuda a identificar se este é o momento
                        certo para você.
                      </p>
                    </li>
                  </ul>
                </ContentList>
              ),
              title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <BaSeIcon
                    name="brain"
                    size="22"
                    color="#fff"
                    description="icon-lightulb-als"
                  />
                  <TittleAccordion>
                    Sobre o perfil comportamental
                  </TittleAccordion>
                </div>
              ),
            },
          ]}
          radius={30}
          titleColor="#ffffff"
        />

        <DEscriptionAccordion>
          Boa entrevista! Estamos com você nessa jornada. Sua transformação
          também é a nossa.
        </DEscriptionAccordion>
      </ContentQuestions>
    </div>
  );
};
